import React, { useState } from 'react';
import StarRatingInput from './StarRatingInput';
import './ReviewEditPanel.css';

const MAX_MESSAGE_LENGTH = 1000;

const getInitials = (name = '') =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return '—';
  return `${date.toLocaleDateString('pt-BR')} ${date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
};

// Conteúdo do SidePanel de edição. Sem campo de "Pedido" / "Informações
// adicionais" (tamanho, cor, altura, tipo de corpo) do mockup original —
// a avaliação ainda não tem vínculo com pedido nem captura esses dados,
// então mostrar isso seria inventar informação que não existe.
const ReviewEditPanel = ({ review, onSave, onDelete, onCancel, saving }) => {
  const [rating, setRating] = useState(review.rating);
  const [message, setMessage] = useState(review.message || '');
  const [isDeleted, setIsDeleted] = useState(Boolean(review.isDeleted));

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ ...review, rating, message, isDeleted });
  };

  return (
    <form className="review-edit-panel" onSubmit={handleSubmit}>
      <div className="review-edit-panel__customer">
        <span className="review-edit-panel__avatar">{getInitials(review.name)}</span>
        <div>
          <p className="review-edit-panel__customer-name">{review.name}</p>
          <p className="review-edit-panel__product-name">{review.product?.name}</p>
        </div>
      </div>

      <div className="review-edit-panel__field">
        <label>Avaliação</label>
        <StarRatingInput rating={rating} onChange={setRating} />
      </div>

      <div className="review-edit-panel__field">
        <label htmlFor="review-edit-message">Mensagem</label>
        <textarea
          id="review-edit-message"
          rows={5}
          maxLength={MAX_MESSAGE_LENGTH}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <span className="review-edit-panel__char-count">
          {message.length}/{MAX_MESSAGE_LENGTH}
        </span>
      </div>

      <div className="review-edit-panel__field">
        <label htmlFor="review-edit-status">Status</label>
        <select
          id="review-edit-status"
          value={isDeleted ? 'inactive' : 'active'}
          onChange={(e) => setIsDeleted(e.target.value === 'inactive')}
        >
          <option value="active">Ativa</option>
          <option value="inactive">Inativa</option>
        </select>
        <p className="review-edit-panel__hint">Avaliações inativas não serão exibidas na loja.</p>
      </div>

      <div className="review-edit-panel__field">
        <label>Data da avaliação</label>
        <p className="review-edit-panel__static-value">{formatDate(review.createdAt)}</p>
      </div>

      <button
        type="button"
        className="review-edit-panel__delete"
        onClick={() => onDelete(review)}
        disabled={saving}
      >
        Excluir avaliação
      </button>

      <div className="review-edit-panel__actions">
        <button type="button" className="cp-btn cp-btn--secondary" onClick={onCancel} disabled={saving}>
          Cancelar
        </button>
        <button type="submit" className="cp-btn cp-btn--primary" disabled={saving}>
          {saving ? 'Salvando...' : 'Salvar alterações'}
        </button>
      </div>
    </form>
  );
};

export default ReviewEditPanel;
